import React from "react";

import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import { SaleLotModal } from "components/SaleLotBobbyCalf";

import { SaleRoundName } from "constants/sale";

import {
  currentSaleSelector,
  getAuctionPensByRound,
  getNestedConsignments,
  getNextAvailableAuctionPen,
  getSaleLotsBySale,
  getSaleRoundIdByName,
  selectEidsBySaleLotIdLookup,
} from "selectors";

const BobbyCalfSaleLot = () => {
  const history = useHistory();
  const { saleLotId } = useParams();

  const selectedSale = useSelector(currentSaleSelector);
  const consignments = useSelector(getNestedConsignments);
  const nextAvailableAuctionPen = useSelector(getNextAvailableAuctionPen);
  const saleRoundId = useSelector(state =>
    getSaleRoundIdByName(state, SaleRoundName.BobbyCalf),
  );
  const scans = useSelector(selectEidsBySaleLotIdLookup);

  const saleLots = Object.values(useSelector(getSaleLotsBySale));
  const saleLotToEdit = saleLots.find(sl => sl.id === saleLotId);

  const auctionPens =
    useSelector(getAuctionPensByRound).get(saleRoundId.toString()) || [];
  const auctionPen =
    saleLotToEdit && auctionPens.length
      ? auctionPens.find(ap => ap.auctionPenId === saleLotToEdit.auction_pen_id)
      : {};

  return (
    <SaleLotModal
      closeSelf={() => history.goBack()}
      selectedSale={selectedSale}
      consignments={consignments}
      saleLotToEdit={saleLotToEdit}
      saleLots={saleLots}
      nextAvailableAuctionPen={nextAvailableAuctionPen}
      saleRoundId={saleRoundId}
      scans={scans}
      auctionPens={auctionPens}
      auctionPen={auctionPen}
    />
  );
};

export default BobbyCalfSaleLot;
